import React from 'react';
import PropTypes from 'prop-types';
import useDocumentTitle from '../../hooks/useDocumentTitle';

export const buildTitle = (record, source) => {
  if (!record || !source) {
    return undefined;
  }

  if (typeof source === 'string') {
    return record[source];
  }
  if (source.length > 0) {
    return source
      .map((item) => {
        if (record[item]) {
          return record[item];
        }
        return undefined;
      })
      .filter((value) => {
        return value;
      })
      .join(' - ');
  }

  return undefined;
};

const TitleFromRecord = ({ record, source, action }) => {
  const title = buildTitle(record, source);
  const documentTitle = action
    ? title
      ? `${title} - ${action}`
      : action
    : title || null;
  useDocumentTitle(documentTitle);

  return <span>{title}</span>;
};

TitleFromRecord.propTypes = {
  record: PropTypes.object,
  source: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  action: PropTypes.string,
};

TitleFromRecord.defaultProps = {
  record: {},
  source: undefined,
  action: undefined,
};

export default TitleFromRecord;
